import { useEffect } from 'react';
import socketService from '../services/WebsocketService';
import keycloak from '../services/keycloak';
import { useSwobNotifications } from './NotificationsProvider';

export const useWebSocketService = () => {
  const { addNotifications } = useSwobNotifications();

  useEffect(() => {
    if (!keycloak.authenticated || !keycloak.token) return;

    socketService.connect((message: string) => {
      addNotifications([
        {
          title: 'Error',
          icon: 'icon-triangle-warning',
          description: message,
          timestamp: new Date(),
          color: 'red'
        }
      ]);
    });

    return () => {
      console.log('[Hook] Cleaning up');
    };
  }, []);

  return socketService;
};
